import Vue from "vue";
import Vuex from "vuex";
import api from "../api/api";
import router from "../router/index";
import getters from "./getters";
Vue.use(Vuex);
const modulesFiles = require.context("./modules", true, /\.js$/);
const modules = modulesFiles.keys().reduce((modules, modulePath) => {
  const moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, "$1");
  const value = modulesFiles(modulePath);
  modules[moduleName] = value.default;
  return modules;
}, {});
Vue.use(Vuex);
export default new Vuex.Store({
  modules,
  state: {
    user: {
      LoginType: "agent",
      openId: JSON.parse(localStorage.getItem("user"))
        ? JSON.parse(localStorage.getItem("user")).openId
        : "",
      token: JSON.parse(localStorage.getItem("user"))
        ? JSON.parse(localStorage.getItem("user")).token
        : "",
      agentId: JSON.parse(localStorage.getItem("user"))
        ? JSON.parse(localStorage.getItem("user")).agentId
        : "",
      admin: JSON.parse(localStorage.getItem("user"))
        ? JSON.parse(localStorage.getItem("user")).admin
        : 0
    },
    load: false,
    loginData: JSON.parse(localStorage.getItem("user")) || {},
    fontSize: JSON.parse(localStorage.getItem("fontSize")) || {},
    isLogin: JSON.parse(localStorage.getItem("isLogin")) || false,
    percent: 0,
    fileIdData: {
      uid: null,
      fileId: null
    },
    uploadData: {
      index: null,
      percent: 0
    },
    menus: JSON.parse(localStorage.getItem("user"))
      ? JSON.parse(localStorage.getItem("user")).resources
      : [],
    resources: JSON.parse(localStorage.getItem("user"))
      ? JSON.parse(localStorage.getItem("user")).resources
      : [],
    authList: JSON.parse(localStorage.getItem("authList")) || [],
    dictionaryIdList: undefined //地区列表
  },
  actions: {
    login({ commit }, flag) {
      commit("index.vue", flag);
    },
    signOut(state) {
      state.isLogin = false;
      state.loginData = {};
      localStorage.removeItem("isLogin");
      localStorage.removeItem("user");
    },
    //获取地区列表
    getDictionaryIdList({ dispatch, commit }) {
      let parentId = 2;
      if (process.env.NODE_ENV === "development") {
      }
      api.dictionary.getDictionaryTreeByParentId({ parentId }).then(res => {
        if (res.data) {
          dispatch("getTreeData", res.data).then(val => {
            commit("GET_DICTIONARYID_LIST", val);
          });
        }
      });
    },
    //直接返回地区列表的值
    returnDictionaryIdList({ dispatch, commit }) {
      return new Promise(resolve => {
        let parentId = 2;
        if (process.env.NODE_ENV === "development") {
        }
        api.dictionary.getDictionaryTreeByParentId({ parentId }).then(res => {
          if (res.data) {
            dispatch("getTreeData", res.data).then(val => {
              commit("GET_DICTIONARYID_LIST", val);
              resolve(val);
            });
          }
        });
      });
    },
    //递归清除树图children==[]
    getTreeData({ dispatch }, data) {
      data.forEach(item => {
        if (item.dictionaries.length == 0) {
          item.dictionaries = undefined;
        } else {
          dispatch("getTreeData", item.dictionaries);
        }
      });
      return data;
    },
    //获取权限按钮
    getAuthList({ commit }) {
      api.user.getButtonRoleResourceList().then(res => {
        localStorage.setItem("authList", JSON.stringify(res.data));
        commit("SET_AUTH_LIST", res.data);
      });
    },
    getCurrentUser({ commit, state }) {
      api.agentUserInfo
        .getAgentUserInfo({
          id: state.user.openId
        })
        .then(res => {
          commit("GET_CURRENT_USER", res.data);
        });
    }
  },
  getters: {
    ...getters,
    isLogin: state => state.isLogin,
    loginData: state => state.loginData
  },
  mutations: {
    //赋值给state中的dictionaryIdList
    GET_DICTIONARYID_LIST(state, val) {
      state.dictionaryIdList = val;
    },
    login(state, flag) {
      state.isLogin = flag;
    },
    percent(state, num) {
      state.percent = num;
    },
    getUploadData(state, data) {
      state.uploadData = data;
    },
    getFileIdData(state, data) {
      state.fileIdData = data;
    },
    changeLoad(state, res) {
      state.load = res;
    },
    ChangeFontSize(state, res) {
      state.fontSize = res;
      localStorage.setItem("fontSize", JSON.stringify(res));
    },
    signIn(state, res) {
      state.isLogin = true;
      state.loginData = res;
      state.resources = res.resources;
      localStorage.setItem("isLogin", true);
      localStorage.setItem("user", JSON.stringify(res));
    },
    signOut(state) {
      state.isLogin = false;
      state.loginData = {};
      localStorage.clear();
      localStorage.removeItem("fontSize");
      localStorage.removeItem("isLogin");
      localStorage.removeItem("user");
      localStorage.removeItem("lastRouter");
      router.push("/");
    },
    //权限按钮列表赋值
    SET_AUTH_LIST(state, view) {
      state.authList = view;
    },
    GET_CURRENT_USER(state, view) {
      state.loginData.resources = view.resources;
      state.loginData.roles = view.roles;
      state.resources = view.resources;
      localStorage.setItem("user", JSON.stringify(state.loginData));
    }
  }
});



// WEBPACK FOOTER //
// ./src/store/store.js